import React, { useCallback } from 'react';
import { computedValues, } from '../../../../model/CurriculumStructureViewTypes';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import SelectBox from '../base/SelectBox';
import useT from '../../utils/Translations/useT';
const CurriculumStructureViewSelector = ({ onChange, value, learningPlanType, subjectType, programType, ...props }) => {
    const t = useT();
    const { options } = useEnumerableModel(computedValues(programType, subjectType, learningPlanType));
    const handleStatusChange = useCallback(value => onChange && onChange(value), [
        onChange,
    ]);
    return (<SelectBox isFilterBar options={options} title={t('View')} value={value} onChange={handleStatusChange} {...props}/>);
};
export default CurriculumStructureViewSelector;
